import React from "react";
import ArticleIcon from "@mui/icons-material/Article";

const activate = (event, onClick) => {
  if (event.key === "Enter" || event.key === " ") {
    event.preventDefault();
    onClick?.();
  }
};

export const ModuleCard = ({ moduleItem, onClick }) => {
  return (
    <div
      className="kb-module-card"
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={(e) => activate(e, onClick)}
    >
      <span className="kb-module-card__icon" aria-hidden>
        <ArticleIcon />
      </span>
      <p className="kb-module-card__name">{moduleItem.moduleName}</p>
      <p className="kb-module-card__count">
        {moduleItem.articleCount || 0} Knowledge Base
      </p>
    </div>
  );
};
